module.exports = __webpack_public_path__ + "media/assets/site_images/team/felipe-7630499d5da90bafc0f17178aa7f3156.jpg";